"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filters = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_select_1 = __importDefault(require("react-select"));
var fa_1 = require("react-icons/fa");
var Search_1 = require("../../../components/Search");
require("./index.scss");
var hooks_1 = require("../../../hooks");
var react_i18next_1 = require("react-i18next");
var customSelectStyles = {
    dropdownIndicator: function (base) { return (__assign(__assign({}, base), { color: '#fff' })); },
    control: function (base) { return (__assign(__assign({}, base), { border: '0', boxShadow: 'none', borderRadius: 20, padding: '1px 13px', backgroundColor: '#000', color: '#fff', fontSize: 14, fontWeight: 600, '&:hover': {
            border: '0',
        } })); },
    placeholder: function (defaultStyles) { return (__assign(__assign({}, defaultStyles), { color: '#fff', fontWeight: 600, fontSize: 14 })); },
    input: function (base) { return (__assign(__assign({}, base), { '[type="text"]': {
            fontFamily: 'Poppins, sans-serif !important',
            fontSize: 14,
            fontWeight: 600,
            color: '#fff !important',
        } })); },
    singleValue: function (provided) { return (__assign(__assign({}, provided), { color: '#fff', fontSize: 14, fontWeight: 600 })); },
    option: function (styles, _a) {
        var isSelected = _a.isSelected, isFocused = _a.isFocused;
        return __assign(__assign({}, styles), { backgroundColor: isSelected || isFocused ? '#98A2B3' : '#fff', color: isSelected || isFocused ? '#fff' : '#000' });
    },
    menu: function (provided) { return (__assign(__assign({}, provided), { zIndex: 20 })); },
};
var Filters = function (_a) {
    var menuList = _a.menuList;
    var setFilters = (0, hooks_1.useSetFilters)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var onChangeMenu = function (option) {
        setFilters({ menu_id: option === null || option === void 0 ? void 0 : option.value });
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "filters" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "filters-container" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "filters-search" }, { children: (0, jsx_runtime_1.jsx)(Search_1.Search, {}) })), (0, jsx_runtime_1.jsx)(react_select_1.default, { styles: customSelectStyles, className: "filters-select", options: menuList, placeholder: t('Select menu'), onChange: onChangeMenu, components: {
                        IndicatorSeparator: function () { return null; },
                        DropdownIndicator: function () { return (0, jsx_runtime_1.jsx)(fa_1.FaAngleDown, { size: 20 }); },
                    } })] })) })));
};
exports.Filters = Filters;
